import { useLayoutEffect } from "react";

export default function ScrollToHashOnLoad() {
    useLayoutEffect(() => {
        const { hash } = window.location;
        if (hash) {
            const id = hash.slice(1);
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "auto" });
            }
        }
    }, []);

    return null;
}
